<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="twofa-setup">
  <div class="twofa-setup__qr-section" *ngIf="qrCode">
    <div class="twofa-setup__instructions">
      <p>{{ 'translations.account.settings.twoFactor.instructions' | transloco }}</p>
    </div>
    <div class="twofa-setup__qr-container">
      <img [src]="qrCode" alt="QR Code" class="twofa-setup__qr-image" />
    </div>
    <div class="twofa-setup__secret">
      <label for="encodedSecretStandalone">{{ 'translations.account.settings.twoFactor.secretLabel' | transloco }}</label>
      <input id="encodedSecretStandalone" type="text" [value]="encodedSecret" readonly class="twofa-setup__secret-input" />
    </div>
  </div>

  <form class="twofa-form" (ngSubmit)="submit2FA()" [formGroup]="twoFactorForm" *ngIf="qrCode">
    <div class="input-field-box">
      <label for="verificationCode">{{ 'translations.account.settings.twoFactor.verificationCodeLabel' | transloco }}</label>
      <input
        id="verificationCode"
        type="text"
        [ngClass]="{
          'has-error':
            twoFactorForm.controls['verificationCode'].invalid &&
            twoFactorForm.controls['verificationCode'].touched &&
            twoFactorForm.controls['verificationCode'].status === 'INVALID',
        }"
        formControlName="verificationCode"
        autocomplete="off"
        class="twofa-form__input-field"
        maxlength="6"
        placeholder="000000"
        required
      />
    </div>
    <div class="twofa-form__actions">
      <button
        mat-flat-button
        color="primary"
        class="login-form__submit twofa-form__submit-btn"
        type="submit"
        [disabled]="is2FASetupInProgress || !twoFactorForm.valid"
        title="{{ 'translations.global.button.confirm' | transloco }}"
      >
        <mat-spinner *ngIf="is2FASetupInProgress" [diameter]="16"></mat-spinner>
        <span *ngIf="!is2FASetupInProgress" class="uppercase">{{ 'translations.global.button.confirm' | transloco }}</span>
      </button>
      <button mat-button type="button" class="uppercase" (click)="regenerateQRCode()" title="Try Again">
        <span>{{ 'translations.framework.button.tryAgain' | transloco }}</span>
      </button>
    </div>
  </form>

  <div *ngIf="is2FAErrorShown" class="twofa-setup__error">
    <span>{{ 'translations.account.settings.message.error.twoFactor' | transloco }}</span>
  </div>

  <div class="twofa-form__logout-actions">
    <button mat-button type="button" color="warn" class="uppercase twofa-form__logout-btn" (click)="requestLogout()" title="Logout">
      <span>{{ 'translations.global.button.logout' | transloco }}</span>
    </button>
  </div>
</div>
